import { Button, Result } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

interface ForbiddenPageProps {
  requiredPermission?: string
}

export default function ForbiddenPage({ requiredPermission }: ForbiddenPageProps) {
  const navigate = useNavigate()

  return (
    <Result
      status="403"
      icon={<LockOutlined />}
      title="无权限访问"
      subTitle={
        requiredPermission
          ? `当前账号缺少权限码 "${requiredPermission}"，无法访问此页面。`
          : '当前账号没有权限访问此页面。'
      }
      extra={
        <Button type="primary" onClick={() => navigate('/dashboard', { replace: true })}>
          返回工作台
        </Button>
      }
    />
  )
}
